import { Col, Row, Spin, Tag, Typography, Card } from "antd";
import { useSelector } from "react-redux";
import { 
  Globe, 
  Smartphone, 
  Link2, 
  BarChart3, 
  User, 
  ShoppingCart, 
  DollarSign, 
  CreditCard, 
  Truck, 
  Package,
  Store,
} from "lucide-react";
import { selectOrderModalIsOpen } from "../../../../redux/selectors/orders.selectors";
import { AdminMenuLayout, ModalGenerate } from "../../../../shared/components";
import { useOrderById, useValidateSingleOrder } from "../../hooks/orderById";
import { WrapperOrderById, WrapperOrderByIdSpin } from "../styled";
import { InfoOrderDetails } from "./InfoOrderDetails";
import { InfoUserCard } from "./InfoUserCard";
import { PaymentConfirmation } from "./PaymentConfirmation";
import { Shippings } from "./Shippings";
import { TableOrderById } from "./TableOrderById";
import { decimal } from "../../../../shared/utils/Helper";

const { Title, Text } = Typography;

export const OrderById = () => {
  const { orderForUpdate, changeOrderModal } = useOrderById();
  const { isValidate } = useValidateSingleOrder();
  const orderModalIsOpen = useSelector(selectOrderModalIsOpen);
  // console.log({ orderForUpdate });

  return (
    <AdminMenuLayout pageDescription="OrderById" title="OrderById">
      {!isValidate && (
        <WrapperOrderByIdSpin>
          <Spin size="large" />
        </WrapperOrderByIdSpin>
      )}
      {isValidate && (
        <WrapperOrderById>
          <Row justify="start" style={{ width: "100%" }} gutter={[16, 16]}>
            {/* Header Card */}
            <Col span={24}>
              <Card
                style={{
                  borderRadius: 16,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  border: "1px solid #e8e8e8",
                }}
              >
                <div style={{ display: "flex", flexWrap: "wrap", gap: 12, alignItems: "center" }}>
                  <Title
                    style={{
                      margin: 0,
                      color: "#E95735",
                      fontWeight: 700,
                    }}
                    level={2}
                  >
                    Pedido #{orderForUpdate?.id}
                  </Title>
                  {orderForUpdate?.payment_method && (
                    <Tag 
                      color={orderForUpdate?.payment_method === "online" ? "blue" : "green"}
                      style={{ 
                        fontSize: 14, 
                        padding: "6px 16px", 
                        borderRadius: 20,
                        fontWeight: 500,
                        border: "none"
                      }}
                    >
                      {orderForUpdate?.payment_method === "online" ? "Pago Online" : "Contra Entrega"}
                    </Tag>
                  )}
                  {orderForUpdate?.sources && (
                    <Tag 
                      color={orderForUpdate?.sources === 'webApp' ? "purple" : "orange"}
                      style={{ 
                        fontSize: 13, 
                        padding: "6px 14px", 
                        borderRadius: 20,
                        fontWeight: 500,
                        border: "none",
                        display: "flex",
                        alignItems: "center",
                        gap: 6
                      }}
                    >
                      {orderForUpdate?.sources === 'webApp' ? (
                        <>
                          <Globe size={14} />
                          Página Web
                        </>
                      ) : (
                        <>
                          <Smartphone size={14} />
                          App Móvil
                        </>
                      )}
                    </Tag>
                  )}
                </div>
              </Card>
            </Col>
            {/* Integration ID */}
            {orderForUpdate?.integration_id && (
              <Col span={24}>
                <Card
                  style={{
                    borderRadius: 12,
                    background: "#f5f5f5",
                    border: "1px solid #e8e8e8",
                  }}
                  bodyStyle={{ padding: 12 }}
                >
                  <Text strong style={{ fontSize: 14, display: "flex", alignItems: "center", gap: 8 }}>
                    <Link2 size={16} style={{ color: "#E95735" }} />
                    Integration ID: <Text code style={{ fontSize: 14 }}>{orderForUpdate?.integration_id}</Text>
                  </Text>
                </Card>
              </Col>
            )}
            {/* Estado del pedido */}
            <Col span={12}>
              <Card
                style={{
                  borderRadius: 16,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  border: "1px solid #e8e8e8",
                  height: "100%",
                }}
              >
                <Title
                  style={{
                    marginTop: 0,
                    marginBottom: 16,
                    color: "#E95735",
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    gap: 8
                  }}
                  level={4}
                >
                  <BarChart3 size={20} />
                  Estado del pedido
                </Title>
                {orderForUpdate?.history && (
                  <TableOrderById
                    data={orderForUpdate?.history}
                    userName={`${orderForUpdate?.user?.first_name} ${orderForUpdate?.user?.last_name}`}
                  />
                )}
              </Card>
            </Col>

            {/* Datos del cliente */}
            <Col span={12}>
              <Card
                style={{
                  borderRadius: 16,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  border: "1px solid #e8e8e8",
                  height: "100%",
                }}
              >
                <Title
                  style={{
                    marginTop: 0,
                    marginBottom: 16,
                    color: "#E95735",
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    gap: 8
                  }}
                  level={4}
                >
                  <User size={20} />
                  Datos del cliente
                </Title>
                {orderForUpdate?.shipping_address_meta_data && (
                  <InfoUserCard
                    shipping={JSON.parse(
                      orderForUpdate?.shipping_address_meta_data
                    )}
                    dataUser={orderForUpdate?.user}
                  />
                )}
              </Card>
            </Col>
            {/* Detalles del Pedido */}
            <Col span={24}>
              <Card
                style={{
                  borderRadius: 16,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  border: "1px solid #e8e8e8",
                }}
              >
                <Title
                  style={{
                    marginTop: 0,
                    marginBottom: 16,
                    color: "#E95735",
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    gap: 8
                  }}
                  level={4}
                >
                  <ShoppingCart size={20} />
                  Detalles del Pedido
                </Title>
                {orderForUpdate?.order_details && (
                  <InfoOrderDetails data={orderForUpdate?.order_details} />
                )}
              </Card>
            </Col>
            {/* Resumen de compra */}
            <Col span={12}>
              <Card
                style={{
                  borderRadius: 16,
                  boxShadow: "0 4px 12px rgba(233, 87, 53, 0.15)",
                  border: "2px solid #E95735",
                  background: "linear-gradient(135deg, #E95735 0%, #ff8566 100%)",
                }}
                bodyStyle={{ padding: 24 }}
              >
                <Title
                  style={{
                    marginTop: 0,
                    marginBottom: 20,
                    color: "#ffffff",
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    gap: 8
                  }}
                  level={4}
                >
                  <DollarSign size={20} />
                  Resumen de compra
                </Title>
                <div style={{ color: "#ffffff", fontSize: 14, lineHeight: "28px" }}>
                  {orderForUpdate?.discount_total_amount ? (
                    <div style={{ marginBottom: 8 }}>
                      <Text style={{ color: "rgba(255,255,255,0.9)" }}>Total Descuento:</Text>
                      <Text strong style={{ color: "#ffffff", float: "right" }}>
                        - ${decimal(orderForUpdate?.discount_total_amount)}
                      </Text>
                    </div>
                  ) : null}
                  <div style={{ marginBottom: 8 }}>
                    <Text style={{ color: "rgba(255,255,255,0.9)" }}>Total Productos:</Text>
                    <Text strong style={{ color: "#ffffff", float: "right" }}>
                      ${decimal(orderForUpdate?.total_price_shipping_cost_excl)}
                    </Text>
                  </div>
                  <div style={{ marginBottom: 8 }}>
                    <Text style={{ color: "rgba(255,255,255,0.9)" }}>Total Envío:</Text>
                    <Text strong style={{ color: "#ffffff", float: "right" }}>
                      ${decimal(orderForUpdate?.total_shipping_cost)}
                    </Text>
                  </div>
                  {orderForUpdate?.amount_paid_from_wallet ? (
                    <>
                      <div style={{ marginBottom: 8 }}>
                        <Text style={{ color: "rgba(255,255,255,0.9)" }}>Pagado con Wallet:</Text>
                        <Text strong style={{ color: "#ffffff", float: "right" }}>
                          - ${decimal(orderForUpdate?.amount_paid_from_wallet)}
                        </Text>
                      </div>
                      <div style={{ marginBottom: 8 }}>
                        <Text style={{ color: "rgba(255,255,255,0.9)" }}>Total a pagar:</Text>
                        <Text strong style={{ color: "#ffffff", float: "right" }}>
                          ${decimal(orderForUpdate?.total_price - orderForUpdate?.amount_paid_from_wallet)}
                        </Text>
                      </div>
                    </>
                  ) : null}
                  <div 
                    style={{ 
                      marginTop: 16, 
                      paddingTop: 16, 
                      borderTop: "1px solid rgba(255,255,255,0.3)",
                      fontSize: 18
                    }}
                  >
                    <Text strong style={{ color: "#ffffff" }}>Total:</Text>
                    <Text strong style={{ color: "#ffffff", float: "right", fontSize: 20 }}>
                      ${decimal(orderForUpdate?.total_price)}
                    </Text>
                  </div>
                </div>
              </Card>
            </Col>
            {/* Confirmación de Pagos */}
            <Col span={24}>
              <Card
                style={{
                  borderRadius: 16,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  border: "1px solid #e8e8e8",
                }}
              >
                <Title
                  style={{
                    marginTop: 0,
                    marginBottom: 16,
                    color: "#E95735",
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    gap: 8
                  }}
                  level={4}
                >
                  <CreditCard size={20} />
                  Confirmación de Pagos
                </Title>
                {orderForUpdate?.order_details && <PaymentConfirmation />}
              </Card>
            </Col>

            {/* Envíos */}
            <Col span={24}>
              <Card
                style={{
                  borderRadius: 16,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  border: "1px solid #e8e8e8",
                }}
              >
                <div style={{ marginBottom: 16, display: "flex", flexWrap: "wrap", gap: 8 }}>
                  {orderForUpdate?.store?.name && (
                    <Tag
                      color="green"
                      style={{
                        fontSize: 13,
                        padding: "6px 14px",
                        borderRadius: 20,
                        border: "none",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 6,
                      }}
                    >
                      <Store size={14} />
                      Sede: {orderForUpdate.store.name}
                    </Tag>
                  )}
                  <Tag 
                    color="blue" 
                    style={{ 
                      fontSize: 13, 
                      padding: "6px 14px", 
                      borderRadius: 20,
                      border: "none",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 6
                    }}
                  >
                    <Package size={14} />
                    Método de envío: {`${orderForUpdate?.fulfillment_company.name}`}
                  </Tag>
                </div>
                <Title
                  style={{
                    marginTop: 12,
                    marginBottom: 16,
                    color: "#E95735",
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    gap: 8
                  }}
                  level={4}
                >
                  <Truck size={20} />
                  Envíos
                </Title>
                {orderForUpdate?.order_details && <Shippings />}
              </Card>
            </Col>
          </Row>
        </WrapperOrderById>
      )}
      {orderModalIsOpen && (
        <ModalGenerate
          // height={"50%"}
          width={"calc(89% - 20px)"}
          title={"Generar Envío"}
          onCancel={changeOrderModal}
        />
      )}
    </AdminMenuLayout>
  );
};
